// ============================================================================
// page-service-single / content-sections.js
// ----------------------------------------------------------------------------
// Per-service content repeater (#293) — each iteration renders one
// `.service-content` section, with image + title + description and an
// optional FAQ accordion (`.accordition__item` repeater inside).
//
// Two things to handle:
//
//   1. Alternating layout. Every other `.service-content__container` gets
//      a `--reverse` modifier so the image swaps sides down the page.
//
//   2. Accordion. Each `.accordition__item` head toggles its body.
//      Matches the original inline behaviour exactly:
//        - Click an item → close everything, then open the clicked one.
//        - No initial auto-open (unlike page-faq's accordion).
//        - No second-click-to-close toggle (clicking the same item
//          re-opens it, which is a visual no-op).
//      Height is animated by setting inline `height` to the body wrapper's
//      offsetHeight; CSS handles the transition.
//
// Note the original Oxygen class is `accordition__*` (typo for "accordion")
// — we keep the spelling so the existing CSS keeps working.
// ============================================================================

function applyAlternatingLayout() {
  const containers = document.querySelectorAll(".service-content__container");
  containers.forEach(function (el, index) {
    if (index % 2 === 1) {
      el.classList.add("service-content__container--reverse");
    }
  });
}

function setupAccordion() {
  const items = document.querySelectorAll(".accordition__item");
  if (!items.length) return;

  function openOnly(targetIndex) {
    items.forEach(function (item) {
      item.classList.remove("open");
      const body = item.querySelector(".accordition__body");
      if (body) body.style.height = "0px";
    });

    const target = items[targetIndex];
    if (!target) return;
    const body = target.querySelector(".accordition__body");
    const bodyWrap = target.querySelector(".accordition__body-wrapper");
    if (!body || !bodyWrap) return;

    target.classList.add("open");
    body.style.height = bodyWrap.offsetHeight + "px";
  }

  items.forEach(function (item, index) {
    const head = item.querySelector(".accordition__head");
    if (!head) return;
    head.addEventListener("click", function () {
      openOnly(index);
    });
  });

  // Recompute the open item's height on resize so wrapping changes don't
  // leave a clipped panel.
  window.addEventListener("resize", function () {
    const openItem = document.querySelector(".accordition__item.open");
    if (!openItem) return;
    const body = openItem.querySelector(".accordition__body");
    const bodyWrap = openItem.querySelector(".accordition__body-wrapper");
    if (body && bodyWrap) body.style.height = bodyWrap.offsetHeight + "px";
  });
}

// The alternating-class pass needs the repeater to be in the DOM. The
// original ran it at module top-level (without DOMContentLoaded), which
// only works because the inline code-js was emitted AFTER the repeater
// markup. Vite bundles load in <head> or at the end of <body> depending
// on enqueue order, so wrap in DOMContentLoaded to be safe.
document.addEventListener("DOMContentLoaded", function () {
  applyAlternatingLayout();
  setupAccordion();
});
